import { styled } from '@mui/material/styles';

export const SchedulerFrame = styled('iframe')({
  width: '100%',
  flex: 1,
  minHeight: 0,
  border: 0,
});
